import { selectorFamily } from 'recoil';
import useCatalogAPI from '../../components/api/CatalogAPI';

const ConvertCatalogSelector = selectorFamily({
  key: 'convertCatalogSelector',
  get: (currency) => async () => {
    const api = useCatalogAPI();
    const result = await api.fetchConvertCatalog(currency);
    return result;
  },
});

export default ConvertCatalogSelector;
